import cn from 'classnames';
import React, { useCallback } from 'react';
import { LinkButton } from 'app/blocks/buttons/buttons';
import { ID, l } from 'app/blocks/common/codes';
import SvgIcon from 'app/blocks/common/svg-icon/svg-icon';
import LinkButtonOrLink from 'app/blocks/menu/LinkButtonOrLink';
import ProfileLink from 'app/blocks/menu/user-name/profile-link';
import routes from 'app/pages/routes.json';
import Dropdown from './dropdown';

import './user-name.scss';

type UserNameProps = {
    isAuth: boolean;
    isOpen: boolean;
    user?: {
        name?: string;
    };
    onClick: () => void;
    onClose: () => void;
    onLogout: () => void;
    goToLogin: () => void;
};

const UserName: React.FC<UserNameProps> = ({ goToLogin, isAuth, isOpen, onClick, onClose, onLogout, user }) => {
    const handleKeyDown = useCallback(
        e => {
            if (e.key === 'Space' || e.key === 'Enter') {
                onLogout();
            }
        },
        [onLogout],
    );

    const handleEscape = useCallback(
        e => {
            if (e.key === 'Escape') {
                onClose();
            }
        },
        [onClose],
    );

    return (
        <div className="UserName">
            {isAuth && (
                <div className={cn('UserName-Container', 'ignore-react-onclickoutside')}>
                    <button
                        aria-controls="dropdown-menu"
                        aria-expanded={isOpen}
                        aria-haspopup="true"
                        className="UserName-button"
                        data-seleniumid="user-name"
                        onClick={onClick}
                        onKeyDown={handleEscape}
                        type="button"
                    >
                        {user.name}
                        <SvgIcon.chevron
                            className={cn('UserName-ArrowIcon', { swapped: isOpen })}
                            iconDescr="Arrow up"
                        />
                    </button>
                    {isOpen && (
                        <Dropdown
                            hideOnUrlClick
                            onClickOutside={onClose}
                            onClose={onClose}
                            placement="bottom-center"
                            seleniumId="user-name-dropdown"
                        >
                            <ProfileLink text={l(`${ID.BUTTONS}.TOP_MENU.PROFILE`)} />
                            <LinkButtonOrLink
                                className="UserNameDropdown-item"
                                data-seleniumid="menu-alerts-btn"
                                explicitHref
                                href={routes.alerts}
                            >
                                {l(`${ID.BUTTONS}.TOP_MENU.ALERTS`)}
                            </LinkButtonOrLink>
                            <button
                                className="UserNameDropdown-item"
                                data-seleniumid="menu-logout-btn"
                                onClick={onLogout}
                                onKeyDown={handleKeyDown}
                                type="button"
                            >
                                {l(`${ID.BUTTONS}.TOP_MENU.LOGOUT`)}
                            </button>
                        </Dropdown>
                    )}
                </div>
            )}

            {!isAuth && (
                <div className="menu-btns" data-seleniumid="menu-buttons">
                    <LinkButton data-seleniumid="menu-login-btn" onClick={goToLogin}>
                        {l(`${ID.BUTTONS}.TOP_MENU.LOGIN`)} / {l(`${ID.BUTTONS}.TOP_MENU.REGISTER`)}
                    </LinkButton>
                </div>
            )}
        </div>
    );
};

export default UserName;
